<app-mobile-not-supported></app-mobile-not-supported>
<app-header [activeLink]="1"></app-header>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-2 white-background" id="navSideDis">
      <div class="mt-3 d-flex justify-content-between">
        <div class="d-flex justify-content-between w-100">
          @if (collectionTypeToggle) {
          <p
            id="public"
            class="colorPrivate font-weight-bold mr-3"
            [ngStyle]="selectedOption === 'public' ? dynamicStyle : {}"
            (click)="selectOption('public')"
          >
            Public
          </p>
          } @if (!collectionTypeToggle) {
          <p
            id="private"
            class="colorPrivate font-weight-bold mr-3"
            [ngStyle]="selectedOption === 'private' ? dynamicStyle : {}"
            (click)="selectOption('private')"
          >
            Private
          </p>
          } @if (!typeToggle) {
          <p
            id="company"
            class="colorPrivate font-weight-bold"
            [ngStyle]="selectedOption === 'company' ? dynamicStyle : {}"
            (click)="selectOption('company')"
          >
            Company
          </p>
          } @if (typeToggle) {
          <p
            id="reference"
            class="colorPrivate font-weight-bold"
            [ngStyle]="selectedOption === 'reference' ? dynamicStyle : {}"
            (click)="selectOption('reference')"
          >
            Reference
          </p>
          }
        </div>
      </div>
      <div class="search-container">
        <!-- <i class="fa fa-search search-icon"></i> -->
        <div class="input-wrapper">
          <input
            type="text"
            class="search-input my-background autocomplete"
            [(ngModel)]="searchTerm"
            autocomplete="off"
            placeholder="Search for files or tags"
            (focus)="workingfocus()"
            (keyup)="onSearchKeyPress($event)"
            id="search"
            #multiSearchTerm
            [ngClass]="{
              'is-invalid': searchValidation
            }"
          />
          @if (tagsSearch && tagsSearch.length > 0) {
          <svg
            (click)="tagsSearch = []; searchTerm = ''"
            class="close-search"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.5">
              <path
                d="M5.52051 5.53027L16.0652 16.0749"
                stroke="black"
                stroke-width="1.97344"
                stroke-linecap="round"
              />
              <path
                d="M16.0654 5.53027L5.52075 16.0749"
                stroke="black"
                stroke-width="1.97344"
                stroke-linecap="round"
              />
            </g>
          </svg>
          }
        </div>
        @if (tagsSearch && tagsSearch.length > 0) {
        <ul class="multiple-tag-search">
          @for (i of tagsSearch; track i) {
          <li class="multiTagList" (click)="multiTagSearch(i)">
            {{ i }}
          </li>
          }
        </ul>
        }
      </div>
      @if (searchValidation) {
      <p class="text-danger">{{ searchValidation }}</p>
      }
      <div class="col-lg-12 white-background">
        <div class="tags searchTagss">
          @for (tag of tags; track tag; let i = $index) {
          <div class="tag-element">
            <span
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                padding-left: 5px;
                max-width: 208px;
              "
              >{{ tag }}
              <!-- <p class="tooltip-text">{{ tag }}</p> -->
            </span>

            <span class="remove-tag" (click)="removeTag(i)">
              <img
                src="../../../assets/close-white.png"
                width="12px"
                height="12px"
                style="margin-bottom: 5px"
              />
            </span>
          </div>
          }
        </div>
      </div>
      @if (searchHistory.length) {
      <div class="mt-3 mb-4">
        <h6>Search History</h6>
        <div class="borderHis mb-2"></div>
        <ul class="list-unstyled scrollableSearch">
          @for (item of searchHistory; track item) {
          <li
            class="cursorPointer font-weight-bold w-100 searchCross"
            (click)="selectOption(item)"
          >
            <span
              class="cursorPointer"
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                padding-left: 5px;
              "
              >{{ item }}
            </span>
            <span class="remove-tag" (click)="removeFromHistory(item)">
              <img
                src="../../../assets/close1.png"
                width="10px"
                height="10px"
              />
            </span>
          </li>
          }
        </ul>
        <!-- <div *ngIf="recentFiveTags.length">
                    <h6>Recently Used Tags</h6>
                    <ul class="list-unstyled d-flex flex-wrap recentScrollable">
                      <li class="recentTags font-weight-bold mr-2 mb-2" (click)="selectOption(tag)"
                        *ngFor="let tag of recentFiveTags" style="height: fit-content; cursor: pointer">
                        {{ tag }}
                      </li>
                    </ul>
                  </div> -->
        <div class="ButtonCenter pb-4">
          <button class="clearBtn" (click)="onClearButtonClick()">
            Clear All
          </button>
        </div>
      </div>
      }
    </div>
    <div class="col-lg-10" style="text-align: center">
      <div class="col-lg-12" id="navSideDisRight">
        <div class="d-flex" style="margin-left: -21px">
          <div class="col-lg-7">
            <div class="d-flex align-items-center" style="margin-top: 10px">
              <svg
                id="back-btn"
                [ngClass]="{
                  'visible': currentTabView === 'public' || currentTabView === 'private',
                 }"
                xmlns="http://www.w3.org/2000/svg"
                width="55"
                height="30"
                fill="currentColor"
                class="bi bi-arrow-left cursorPointer fw"
                viewBox="0 0 16 16"
                (click)="goBack()"
              >
                <path
                  fill-rule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                />
              </svg>
              <p class="m-0 fw" id="videoLength">{{ totalMedia }} Files</p>

              <div
                class="mr-2 d-flex align-items-center"
                [class.disabled-div]="playAccess"
              >
                <div>
                  <!-- <p
                    class="m-0 fw cursorPointer"
                    (click)="normalView('normal')"
                  >
                    Normal
                  </p> -->
                </div>
                <div class="onoffswitch mx-2">
                  <input
                    type="checkbox"
                    name="onoffswitch"
                    id="projectType"
                    class="onoffswitch-checkbox"
                    (change)="GridView($event)"
                  />
                  <label for="projectType" class="onoffswitch-label">
                    <span class="onoffswitch-inner project-type-content"></span>
                    <span class="onoffswitch-switch"></span>
                  </label>
                </div>
                <div>
                  <!-- <p class="m-0 fw cursorPointer" (click)="normalView('grid')">
                    Grid
                  </p> -->
                </div>
              </div>
              <div
                (click)="playListOpen()"
                [ngClass]="{
                  'public-tab-active': currentTabView === 'public',
                 }"
                class="cursorPointer public_private"
                routerLinkActive="active-tab-underline"
                [class.disabled-div]="playAccess"
              >
                <p class="m-0 fw" id="playlistDiv">
                  <span class="playPublic">Public</span>
                  <span class="icon">
                    <!-- <img  width="24" height="24" src="../../../assets/public-content.png" alt=""> -->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 256 256"
                    >
                      <path
                        fill="#7b94d5"
                        d="M214.61 198.62a32 32 0 1 0-45.23 0a40 40 0 0 0-17.11 23.32a8 8 0 0 0 5.67 9.79a8.2 8.2 0 0 0 2.06.27a8 8 0 0 0 7.73-5.95C170.56 215.42 180.54 208 192 208s21.44 7.42 24.27 18.05a8 8 0 1 0 15.46-4.11a40 40 0 0 0-17.12-23.32M192 160a16 16 0 1 1-16 16a16 16 0 0 1 16-16m24-88h-84.69L104 44.69A15.86 15.86 0 0 0 92.69 40H40a16 16 0 0 0-16 16v144.61A15.4 15.4 0 0 0 39.38 216h81.18a8 8 0 0 0 0-16H40V88h176v32a8 8 0 0 0 16 0V88a16 16 0 0 0-16-16M92.69 56l16 16H40V56Z"
                      />
                    </svg>
                  </span>
                </p>
              </div>
              <div
                (click)="playUsers()"
                [ngClass]="{
                  'private-tab-active': currentTabView === 'private',
                 }"
                class="ml-3 cursorPointer public_private"
                routerLinkActive="active"
                [class.disabled-div]="playAccess"
              >
                <p class="m-0 fw" id="playlistUser">
                  <span class="playPublic">Private</span>
                  <span class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#7b94d5"
                        d="M9.367 2.25h5.266c1.092 0 1.958 0 2.655.057c.714.058 1.317.18 1.869.46a4.75 4.75 0 0 1 2.075 2.077c.281.55.403 1.154.461 1.868c.057.697.057 1.563.057 2.655V10.8a.75.75 0 0 1-1.5 0V9.4c0-1.132 0-1.937-.052-2.566c-.05-.62-.147-1.005-.302-1.31a3.25 3.25 0 0 0-1.42-1.42c-.305-.155-.69-.251-1.31-.302c-.63-.051-1.434-.052-2.566-.052H9.4c-1.132 0-1.937 0-2.566.052c-.62.05-1.005.147-1.31.302a3.25 3.25 0 0 0-1.42 1.42c-.155.305-.251.69-.302 1.31c-.051.63-.052 1.434-.052 2.566v5.2c0 1.133 0 1.937.052 2.566c.05.62.147 1.005.302 1.31a3.25 3.25 0 0 0 1.42 1.42c.305.155.69.251 1.31.302c.63.051 1.434.052 2.566.052H12a.75.75 0 0 1 0 1.5H9.367c-1.092 0-1.958 0-2.655-.057c-.714-.058-1.317-.18-1.868-.46a4.75 4.75 0 0 1-2.076-2.076c-.281-.552-.403-1.155-.461-1.869c-.057-.697-.057-1.563-.057-2.655V9.367c0-1.092 0-1.958.057-2.655c.058-.714.18-1.317.46-1.868a4.75 4.75 0 0 1 2.077-2.076c.55-.281 1.154-.403 1.868-.461c.697-.057 1.563-.057 2.655-.057"
                      />
                      <path
                        fill="#7b94d5"
                        d="M15.536 14.778c0-1.37 1.077-2.528 2.464-2.528s2.464 1.158 2.464 2.528v.732q.093.036.184.083c.386.204.694.526.885.915c.13.264.176.535.197.802c.02.252.02.557.02.907v.677c0 .35 0 .655-.02.907a2.2 2.2 0 0 1-.197.802c-.192.39-.5.711-.885.915a2 2 0 0 1-.797.211c-.247.021-.544.021-.88.021h-1.943c-.335 0-.632 0-.879-.02a2 2 0 0 1-.797-.212a2.06 2.06 0 0 1-.885-.915a2.2 2.2 0 0 1-.197-.802c-.02-.252-.02-.557-.02-.907v-.677c0-.35 0-.655.02-.907c.02-.267.068-.538.197-.802c.191-.39.5-.711.885-.915q.09-.048.184-.083zm1.5.583h1.928v-.583c0-.594-.457-1.028-.964-1.028s-.964.434-.964 1.028zm-.76 1.516c-.166.014-.212.036-.224.043a.56.56 0 0 0-.239.25a.8.8 0 0 0-.048.258a12 12 0 0 0-.015.816v.623c0 .385 0 .63.015.816c.014.178.038.237.048.258c.055.112.14.198.24.25c.011.007.057.03.223.044c.175.014.408.015.781.015h1.886c.373 0 .606 0 .781-.015c.166-.014.212-.037.224-.043a.56.56 0 0 0 .239-.25a.8.8 0 0 0 .048-.259c.015-.186.015-.431.015-.816v-.623c0-.385 0-.63-.015-.816a.8.8 0 0 0-.048-.258a.56.56 0 0 0-.24-.25c-.011-.007-.057-.03-.223-.043a10 10 0 0 0-.781-.016h-1.886c-.373 0-.606 0-.781.016"
                      />
                      <path
                        fill="#7b94d5"
                        d="M18 17.75a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 .75-.75M5.25 6A.75.75 0 0 1 6 5.25h12a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 6m0 3A.75.75 0 0 1 6 8.25h8.5a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 9m0 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m3-3a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m-3 3a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75"
                      />
                    </svg>
                    <!-- <img width="24" height="24" src="../../../assets/private-content.png" alt=""> -->
                  </span>
                </p>
              </div>
              <!-- *ngIf="invitationDetailslength > 0" -->
              @if (invitationDetailslength > 0) {
              <div
                (click)="getInvitation()"
                class="ml-3 cursorPointer public_private"
              >
                <div class="notification-icon" title="Request">
                  <p
                    class="m-0 fw"
                    id="playlist"
                    data-toggle="modal"
                    data-target="#requestModal"
                    [class.active]="activeTab === 'playlist'"
                  >
                    <img
                      width="20"
                      height="20"
                      src="../../../assets/fluent-mdl2--add-friend.png"
                      alt=""
                    />
                    <span class="notification-count">{{
                      invitationDetailslength
                    }}</span>
                  </p>
                </div>
              </div>
              }

              <!-- Deck -->
              <button
                class="ml-3 d-flex align-items-center cursorPointer public_private btn"
                [disabled]="selectedPresentations.length === 0"
                (click)="onDeckClick()"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    style="opacity: 0.65"
                    fill="currentColor"
                    d="M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1"
                  />
                </svg>
                <p class="mb-0 ml-1 fw">Deck</p>
              </button>

              <!-- Get Deck -->
              <div (click)="getDecks()">
                <div
                  class="ml-3 d-flex align-items-center cursorPointer public_private"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      style="opacity: 0.65"
                      fill="currentColor"
                      d="M12 15.575q-.2 0-.375-.062T11.3 15.3l-3.6-3.6q-.3-.3-.288-.7t.288-.7q.3-.3.713-.312t.712.287L11 12.15V5q0-.425.288-.712T12 4t.713.288T13 5v7.15l1.875-1.875q.3-.3.713-.288t.712.313q.275.3.288.7t-.288.7l-3.6 3.6q-.15.15-.325.213t-.375.062M6 20q-.825 0-1.412-.587T4 18v-2q0-.425.288-.712T5 15t.713.288T6 16v2h12v-2q0-.425.288-.712T19 15t.713.288T20 16v2q0 .825-.587 1.413T18 20z"
                    />
                  </svg>
                  <p class="mb-0 ml-1 fw">Decks</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 mt-25 d-flex justify-content-end sort_content">
            <div class="d-flex align-items-center">
              <div class="date-sort-wrapper position-relative mr-2">
                <div
                  class="filter-action-btn date-sort-trigger cursorPointer"
                  (click)="open($event)"
                  title="Filter by date range"
                >
                  <i class="far fa-calendar-alt filter-btn-icon"></i>
                  <span class="filter-btn-label">
                    <span>Sort By</span>
                    @if (fromMonthSelected && fromDateSelected) {
                      <span id="customDateText" class="custom-date-text ml-1">
                        : {{ fromMonthSelected }} {{ fromDateSelected }} - {{ toMonthSelected }} {{ toDateSelected }}
                      </span>
                    }
                  </span>
                  <i class="fa fa-caret-down filter-caret"></i>
                </div>

                <div class="fx-date-range-container">
                  <input
                    #matSortBy
                    class="fx-date-range"
                    type="text"
                    matInput
                    ngxDaterangepickerMd
                    [locale]="{ applyLabel: 'OK', cancelLabel: 'Cancel', clearLabel: 'Clear', format: 'MM/DD/YYYY' }"
                    [drops]="'down'"
                    [opens]="'left'"
                    [ranges]="ranges"
                    [showCustomRangeLabel]="false"
                    [alwaysShowCalendars]="true"
                    [keepCalendarOpeningWithRange]="true"
                    [showCancel]="true"
                    [showClearButton]="true"
                    autocomplete="off"
                    name="daterange"
                    (change)="onDateSelected($event)"
                    (hide)="onDatepickerHide()"
                  />
                </div>
              </div>

              @if ( currentTabView !== 'private' && currentTabView !== 'public' ) {
              <div class="dropdown filter-action-dropdown mr-2">
                <button
                  #filterDropdownContainer
                  class="btn dropdown-toggle filter-action-btn"
                  type="button"
                  id="dropdownMenuButtonFilter"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  (click)="filterBaseOnUploader(currentTabView)"
                >
                  <i class="fas fa-filter filter-btn-icon"></i>
                  <span class="filter-btn-label text-capitalize">{{
                    filteredName || "Filter"
                  }}</span>
                  <i class="fa fa-caret-down filter-caret"></i>
                </button>
                <ul
                  #filterDropdownMenu
                  class="dropdown-menu filter-menu-card"
                  aria-labelledby="dropdownMenuButtonFilter"
                >
                  <li
                    class="dropdown-item cursorPointer"
                    [class.active-item]="!filteredName || filteredName.toLowerCase() === 'all'"
                    (click)="filterItemsByExtension('all', $event)"
                  >
                    <span class="d-flex align-items-center">
                      <i class="fas fa-layer-group filter-item-icon mr-2 text-muted"></i>
                      <span>All Files</span>
                    </span>
                    @if (!filteredName || filteredName.toLowerCase() === 'all') {
                      <i class="fas fa-check item-check-icon"></i>
                    }
                  </li>
                  <li
                    class="dropdown-item cursorPointer"
                    [class.active-item]="filteredName && filteredName.toLowerCase() === 'pdf'"
                    (click)="filterItemsByExtension('pdf', $event)"
                  >
                    <span class="d-flex align-items-center">
                      <i class="far fa-file-pdf filter-item-icon mr-2 text-danger"></i>
                      <span>PDF</span>
                    </span>
                    @if (filteredName && filteredName.toLowerCase() === 'pdf') {
                      <i class="fas fa-check item-check-icon"></i>
                    }
                  </li>
                  <li
                    class="dropdown-item cursorPointer"
                    [class.active-item]="filteredName && filteredName.toLowerCase() === 'videos'"
                    (click)="filterItemsByExtension('videos', $event)"
                  >
                    <span class="d-flex align-items-center">
                      <i class="far fa-file-video filter-item-icon mr-2 text-primary"></i>
                      <span>Videos</span>
                    </span>
                    @if (filteredName && filteredName.toLowerCase() === 'videos') {
                      <i class="fas fa-check item-check-icon"></i>
                    }
                  </li>
                  <li
                    class="dropdown-item cursorPointer"
                    [class.active-item]="filteredName && filteredName.toLowerCase() === 'images'"
                    (click)="filterItemsByExtension('images', $event)"
                  >
                    <span class="d-flex align-items-center">
                      <i class="far fa-file-image filter-item-icon mr-2 text-success"></i>
                      <span>Images</span>
                    </span>
                    @if (filteredName && filteredName.toLowerCase() === 'images') {
                      <i class="fas fa-check item-check-icon"></i>
                    }
                  </li>
                  <li
                    class="dropdown-item cursorPointer"
                    [class.active-item]="filteredName && (filteredName.toLowerCase() === 'pptx' || filteredName.toLowerCase() === 'presentation')"
                    (click)="filterItemsByExtension('pptx', $event)"
                  >
                    <span class="d-flex align-items-center">
                      <i class="far fa-file-powerpoint filter-item-icon mr-2 text-warning"></i>
                      <span>Presentation</span>
                    </span>
                    @if (filteredName && (filteredName.toLowerCase() === 'pptx' || filteredName.toLowerCase() === 'presentation')) {
                      <i class="fas fa-check item-check-icon"></i>
                    }
                  </li>
                  <li
                    class="dropdown-item cursorPointer"
                    [class.active-item]="filteredName && filteredName.toLowerCase() === 'docs'"
                    (click)="filterItemsByExtension('docs', $event)"
                  >
                    <span class="d-flex align-items-center">
                      <i class="far fa-file-word filter-item-icon mr-2 text-info"></i>
                      <span>Docs</span>
                    </span>
                    @if (filteredName && filteredName.toLowerCase() === 'docs') {
                      <i class="fas fa-check item-check-icon"></i>
                    }
                  </li>
                  <li
                    class="dropdown-item cursorPointer"
                    [class.active-item]="filteredName && filteredName.toLowerCase() === 'excel'"
                    (click)="filterItemsByExtension('excel', $event)"
                  >
                    <span class="d-flex align-items-center">
                      <i class="far fa-file-excel filter-item-icon mr-2 text-success"></i>
                      <span>Excel</span>
                    </span>
                    @if (filteredName && filteredName.toLowerCase() === 'excel') {
                      <i class="fas fa-check item-check-icon"></i>
                    }
                  </li>
                </ul>
              </div>
              }

              @if (currentTabView !== 'private') {
              <div class="dropdown filter-action-dropdown">
                <button
                  class="btn dropdown-toggle filter-action-btn"
                  type="button"
                  id="dropdownMenuButtonUpload"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  (click)="filterBaseOnUploader(currentTabView)"
                >
                  <i class="far fa-user filter-btn-icon"></i>
                  <span class="filter-btn-label text-capitalize">{{
                    nameDisplay || "Uploaded By"
                  }}</span>
                  <i class="fa fa-caret-down filter-caret"></i>
                </button>
                <ul
                  class="dropdown-menu filter-menu-card upload-by-menu"
                  aria-labelledby="dropdownMenuButtonUpload"
                >
                  @for (name of nameList; track name) {
                  <li
                    class="dropdown-item cursorPointer"
                    [class.active-item]="nameDisplay === name"
                    (click)="selectName(name, currentTabView, $event)"
                  >
                    <span class="d-flex align-items-center text-truncate">
                      <span class="user-avatar-badge mr-2">{{ name ? name.charAt(0).toUpperCase() : 'U' }}</span>
                      <span class="text-truncate">{{ name }}</span>
                    </span>
                    @if (nameDisplay === name) {
                      <i class="fas fa-check item-check-icon ml-2"></i>
                    }
                  </li>
                  }
                </ul>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      <!-- <router-outlet></router-outlet> -->

      @if (!isShimmerLoading && (currentTabView !== 'public' && currentTabView
      !== 'private' ) || (isPrevCardFolders && currentTabView === 'public') ||
      (isPrevCardFolders && currentTabView === 'private') ) {
      <div
        class="col-lg-12 pb-5 adjust-height scrollable overflow-x-hidden"
        infiniteScroll
        #infiniteScroller
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="500"
        (scrolled)="onScroll()"
        [scrollWindow]="false"
        [ngClass]="currentTabView === 'grid' ? 'four-view' : 'three-view'"
      >
        @for (card of cardData; track card; let i = $index) {
        <div class="card card-cont" (click)="working(card._id, $event)">
          <!-- TEMPORARY UPLOADING PREVIEW -->
          @if (card.isUploading) {
          <div
            class="uploading-preview text-center position-relative"
            style="height: 245px"
          >
            <div class="overlay"></div>

            <div class="progress-container">
              <div class="progress" style="height: 8px">
                <div
                  class="progress-bar"
                  role="progressbar"
                  [style.width.%]="card.progress"
                  [attr.aria-valuenow]="card.progress"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <p class="text-center small mb-1" style="color: #fff">
                Uploading... {{ card.progress }}%
              </p>
            </div>

            <!-- IMAGE PREVIEW -->
            @if (card.extension == '.jpeg' || card.extension == '.jpg' ||
            card.extension == '.png' || card.extension == '.webp') {
            <img
              [src]="card.ogFileUrl"
              class="img-thumbnail"
              style="object-fit: contain; max-height: 200px; margin: auto"
            />
            }

            <!-- VIDEO PREVIEW -->
            @if ( card.ogFileUrl && (card.extension == '.mp4' || card.extension
            == '.webm' || card.extension == '.mov' || card.extension == '.mkv')
            ) {
            <video
              [src]="card.ogFileUrl"
              controls
              preload="metadata"
              style="
                width: 100%;
                height: 242px;
                object-fit: contain;
                position: absolute;
                top: 1%;
              "
              playsinline
            ></video>
            }

            <!-- PDF -->
            @if (card.extension == '.pdf') {
            <img
              src="assets/Archive_files/pdf.png"
              height="69%"
              width="35%"
              style="object-fit: contain; margin: 10px auto; padding-top: 1rem"
            />
            }

            <!-- PPT -->
            @if (card.extension == '.pptx' || card.extension == '.ppt') {
            <img
              src="assets/Archive_files/pptx.png"
              height="69%"
              width="45%"
              style="object-fit: contain; margin: 10px auto; padding-top: 1rem"
            />
            }

            <!-- DOC -->
            @if (card.extension == '.docx' || card.extension == '.doc') {
            <img
              src="assets/docx-img.png"
              height="69%"
              width="35%"
              style="object-fit: contain; margin: 10px auto; padding-top: 1rem"
            />
            }

            <!-- EXCEL & CSV -->
            @if (card.extension == '.xlsx' || card.extension == '.xls' || card.extension == '.csv') {
            <img
              src="assets/Archive_files/excel-icon.png"
              height="69%"
              width="35%"
              style="object-fit: contain; margin: 10px auto; padding-top: 1rem"
            />
            }
          </div>
          } @else {
          <!--  FINAL PREVIEW (normal files after upload completes) -->

          @if ((card.ogFileUrl && card.extension == '.jpeg') || card.extension
          == '.png' || card.extension == '.jpg' || card.extension == '.webp') {
          <img
            class="img-thumbnail"
            id="image"
            [src]="card.ogFileUrl"
            height="100%"
            style="object-fit: contain"
          />
          } @if (card.ogFileUrl && card.extension == '.pptx') {
          <div class="ppt-checkbox-wrapper">
            <input
              type="checkbox"
              class="select-ppt"
              [checked]="selectedPresentations.includes(card._id)"
              [disabled]="
                selectedPresentations.length >= maxSelectionLimit &&
                !selectedPresentations.includes(card._id)
              "
              (click)="$event.stopPropagation()"
              (change)="presentationSelection(card._id)"
            />
            @if(getSelectionIndex(card._id) !== -1) {
            <span class="selection-number">
              {{ getSelectionIndex(card._id) + 1 }}
            </span>
            }
          </div>
          <img
            src="assets/Archive_files/pptx.png"
            height="69%"
            width="45%"
            style="object-fit: contain; margin: 10px auto"
            alt=""
          />
          } @if (card.ogFileUrl && card.extension == '.pdf') {
          <img
            src="assets/Archive_files/pdf.png"
            height="69%"
            width="35%"
            style="object-fit: contain; margin: 10px auto; padding-top: 1rem"
            alt=""
          />
          } @if ((card.ogFileUrl && card.extension == '.doc') || card.extension
          == '.docx') {
          <img
            src="../../../assets/docx-img.png"
            height="69%"
            width="35%"
            style="object-fit: contain; margin: 10px auto; padding-top: 1rem"
            alt=""
          />
          } @if ((card.ogFileUrl && card.extension == '.xls') || card.extension
          == '.xlsx' || card.extension == '.csv') {
          <img
            src="../../../assets/Archive_files/excel-icon.png"
            height="69%"
            width="35%"
            style="object-fit: contain; margin: 10px auto; padding-top: 1rem"
            alt=""
          />
          }
          <!-- VIDEO PREVIEW FINAL -->
          @if (card.extension == '.mp4' || card.extension == '.webm' ||
          card.extension == '.mov' || card.extension == '.mkv') {
          <div
            id="videothumnail"
            class="videoThumbnail"
            style="display: grid"
            (mouseenter)="showControls(i)"
            (mouseleave)="hideControls(i)"
            (click)="toggleVideo(i)"
          >
            <div class="p-2" style="justify-self: center">
              @if (card.gif && card.selectedThumbnail) {
              <video
                #mediaElement
                id="video"
                [src]="card.gif"
                preload="auto"
                [muted]="true"
                style="
                  width: 100%;
                  height: 223px;
                  max-width: 100%;
                  justify-self: center;
                "
                loop
                playsinline="true"
                poster="{{ card.selectedThumbnail }}"
              ></video>
              } @else {
              <img
                src="../../../assets/video-file.jpg"
                alt="Video processing"
                style="
                  width: 100%;
                  height: 223px;
                  object-fit: contain;
                  border-radius: 6px;
                "
              />
              }
            </div>
          </div>
          } }

          <div class="card-body d-flex flex-column">
            <div class="d-flex justify-content-between">
              <h5
                class="card-title mb-0"
                style="
                  bottom: 35px;
                  max-width: 80%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ card.title }}
              </h5>
              <p
                class="mb-2"
                style="font-size: 16px; font-weight: 600; margin-top: 4px"
              >
                {{ card.isPublic ? "Public" : "Private" }}
              </p>
            </div>
            <div class="d-flex align-items-center heightDetails">
              <div>
                @if (card.profileImg) {
                <img
                  src="{{ card.profileImg }}"
                  style="border-radius: 50%; height: 20px; width: 20px"
                />
                } @if (!card.profileImg) {
                <img
                  src="../../../assets/add-people.png"
                  width="20px"
                  height="20px"
                />
                }
              </div>
              <div>
                <p class="text-black m-0">{{ card.uploadedBy }}</p>
              </div>
              <div class="dot"></div>
              <div>
                <p class="text-grey m-0">{{ card.createdAt | date }}</p>
              </div>
              <div class="moreOptions">
                <div class="dropdown" (click)="handleDropdownItemClick($event)">
                  <ul
                    class="dropbtn icons btn-right showLeft"
                    (click)="showDropdown(i)"
                  >
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
                  <div
                    id="myDropdown"
                    [ngClass]="{ show: isDropdownOpen === i }"
                    class="dropdown-content"
                  >
                    <!-- <a class="d-flex align-items-center gapP" (click)="download(card._id)" > <img src="../../../assets/downloadP.png" /> <span>Download</span> </a> -->
                    @if ( currentTabView !== 'public' && currentTabView !==
                    'private' ) {
                    <a
                      class="d-flex align-items-center gapP"
                      (click)="savePlayList(i, card._id)"
                      data-toggle="modal"
                      data-target="#saveModal"
                    >
                      <img
                        width="22"
                        height="22"
                        src="../../../assets/icons 6/save-icon.svg"
                      />
                      <span>Add to collection</span>
                    </a>
                    } @if (guestId === card.userId) {
                    <a
                      class="d-flex align-items-center gapP"
                      (click)="deleteMedia(card._id)"
                    >
                      <img
                        width="24"
                        height="24"
                        src="../../../assets/icons 6/delete-blue.svg"
                      />
                      <span>Delete</span>
                    </a>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        } @if (!isShimmerLoading && cardData.length === 0 && notFoundResult) {
        <div class="notFoundData" id="notFound" style="transform: translate(100%, -14%)">
          <img src="../../../assets/not1.png" width="100%" height="100%" />
        </div>
        }
      </div>

      } @if(isShimmerLoading) { @for (card of shimmerLoadingValue; track card;
      let i = $index) {
      <span class="d-flex">
        <div class="shimmer-card">
          <div class="shimmerBG media"></div>
          <div class="p-32">
            <div class="shimmerBG title-line"></div>
            <div class="shimmerBG title-line end"></div>

            <div class="shimmerBG content-line m-t-24"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line end"></div>
          </div>
        </div>

        <div class="shimmer-card">
          <div class="shimmerBG media"></div>
          <div class="p-32">
            <div class="shimmerBG title-line"></div>
            <div class="shimmerBG title-line end"></div>

            <div class="shimmerBG content-line m-t-24"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line end"></div>
          </div>
        </div>

        <div class="shimmer-card">
          <div class="shimmerBG media"></div>
          <div class="p-32">
            <div class="shimmerBG title-line"></div>
            <div class="shimmerBG title-line end"></div>

            <div class="shimmerBG content-line m-t-24"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line end"></div>
          </div>
        </div>
      </span>
      } }

      <!-- Public && Private view -->
      @if (!isShimmerLoading && (currentTabView === 'public' || currentTabView
      === 'private')){

      <div
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="500"
        (scrolled)="onPublicScroll()"
        [scrollWindow]="false"
        class="col-lg-12 pb-5 adjust-height three-view scrollable overflow-x-hidden"
      >
        <div style="display: contents" id="publicData">
          @for (card of cardData; track card; let i = $index) {
          <div class="card-container">
            <div
              class="card card-cont"
              (click)="
                displayPlayList(card._id, 0, card.isPublic, card.creatorId)
              "
            >
              <img
                class="folder"
                id="image"
                src="assets/folder-new.jpg"
                width="100%"
                height="100%"
              />
              @for (item of card.media; track item) {
              <div class="position-relative">
                <div style="width: 100%; position: relative">
                  @if (item.thumbnail) {
                  <img
                    class="folder"
                    id="image"
                    [src]="item.thumbnail"
                    width="100%"
                    height="100%"
                  />
                  }
                  <div class="thumbnail-overlay">
                    <svg
                      class="icon"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                      focusable="false"
                    >
                      <path
                        d="M22 7H2v1h20V7zm-9 5H2v-1h11v1zm0 4H2v-1h11v1zm2 3v-8l7 4-7 4z"
                      ></path>
                    </svg>
                    <span>{{ card.media.length }} Files</span>
                  </div>
                </div>
              </div>
              }
              <div
                class="card-body d-flex flex-column"
                style="border-top: none"
              >
                <h5 class="card-title d-flex fixed-width">
                  {{ card.title }}
                  <P style="font-size: 16px">{{
                    card.isPublic ? "Public" : "Private"
                  }}</P>
                </h5>
                <div class="d-flex align-items-center heightDetails">
                  <div>
                    @if (card.creatorProfileImg) {
                    <img
                      src="{{ card.creatorProfileImg }}"
                      width="30px"
                      height="30px"
                      style="border-radius: 50%"
                    />
                    }
                  </div>
                  <div>
                    @if (!card.creatorProfileImg) {
                    <img
                      src="../../../assets/add-people.png"
                      width="20px"
                      height="20px"
                    />
                    }
                  </div>
                  <p class="text-black m-0">
                    {{ card.creatorName }}
                  </p>
                  <div class="dot"></div>
                  <div>
                    <p class="text-grey m-0">{{ card.createdAt | date }}</p>
                  </div>
                  <div class="moreOptions">
                    <div
                      class="dropdown"
                      (click)="handleDropdownItemClick($event)"
                    >
                      <ul
                        class="dropbtn icons btn-right showLeft"
                        (click)="showDropdown(i)"
                      >
                        <li></li>
                        <li></li>
                        <li></li>
                      </ul>
                      <div
                        id="myDropdown "
                        [ngClass]="{ show: isDropdownOpen === i }"
                        class="dropdown-content playDelete"
                      >
                        <!-- <a
                                            class="d-flex align-items-center gapP"
                                            (click)="download(card._id)"
                                            >
                                            <img src="../../../assets/downloadP.png" />
                                            <span>Download</span>
                                          </a> -->
                        <!-- *ngIf="userId === guestId" -->
                        @if (guestId === card.creatorId) {
                        <a
                          class="d-flex align-items-center gapP"
                          (click)="deleteCollectionMedia(card._id)"
                        >
                          <img
                            width="32px"
                            src="../../../assets/icons 6/delete-blue.svg"
                          />
                          <span>Delete PlayList</span>
                        </a>
                        }

                        <a
                          class="d-flex align-items-center gapP"
                          data-toggle="modal"
                          data-target="#shareP"
                          (click)="shareList(card._id)"
                        >
                          <img
                            style="width: 28px"
                            src="../../../assets/Archive_files/share_collection.svg"
                          />
                          <span>Share</span>
                        </a>

                        <a
                          class="d-flex align-items-center gapP"
                          data-toggle="modal"
                          data-target="#collaborate"
                          (click)="collaborate(card)"
                        >
                          <img
                            style="width: 28px"
                            src="../../../assets/join.svg"
                          />
                          <span>Collaborate</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        @if (cardData.length === 0) {
        <div class="notFoundData" style="transform: translate(85%, -25%)">
          <img src="../../../assets/not1.png" width="100%" height="100%" />
        </div>
        } @if (notFoundResult) {
        <div class="notFoundData" style="transform: translate(85%, -25%)">
          <img src="../../../assets/not1.png" width="100%" height="100%" />
        </div>
        }
      </div>
      }
    </div>

    <div class="row"></div>
  </div>
  <!-- modals   -->
  <div
    class="saveModal modal fade"
    id="saveModal"
    tabindex="-1"
    aria-labelledby="networkErrorModal"
    aria-hidden="true"
    (click)="closeModal($event)"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            Create New Collection
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true" (click)="closeModal($event)">&times;</span>
          </button>
        </div>
        <div class="">
          <div class="modal-body text-left saveModal">
            <div>
              <label class="collection-title" for="collection"
                >Collection Title:</label
              >
              <input type="text" class="form-control collection-input" />
            </div>
            <div class="dropdown type">
              Type:
              <button
                class="btn btn-secondary dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <span class="text-capitalize centerType textblack">{{
                  collectionType || "Add To Collection"
                }}</span>
                <i class="fa fa-caret-down centerType textblack"></i>
              </button>
              <div class="dropdown-menu drop-down-type">
                <div
                  class="dropdown-item cursorPointer text-capitalize"
                  (click)="addCollectionType('Private')"
                >
                  <span class="icon-text-wrapper d-flex align-items-center">
                    <div class="icon">
                      <svg
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        focusable="false"
                      >
                        <path
                          d="M17 8V6.63C17 4.08 14.76 2 12 2S7 4.08 7 6.63V8H4v14h16V8h-3zM8 6.63c0-2.02 1.79-3.66 4-3.66s4 1.64 4 3.66V8H8V6.63zM19 21H5V9h14v12zm-7-9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                        ></path>
                      </svg>
                    </div>
                    Private
                  </span>
                </div>
                <div
                  class="dropdown-item cursorPointer text-capitalize"
                  (click)="addCollectionType('Public')"
                >
                  <span class="icon-text-wrapper d-flex align-items-center">
                    <div class="icon">
                      <svg
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        focusable="false"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM3 12c0-.7.09-1.37.24-2.02L8 14.71v.79c0 1.76 1.31 3.22 3 3.46v1.98c-4.49-.5-8-4.32-8-8.94zm8.5 6C10.12 18 9 16.88 9 15.5v-1.21l-5.43-5.4C4.84 5.46 8.13 3 12 3c1.05 0 2.06.19 3 .53V5c0 .55-.45 1-1 1h-3v2c0 .55-.45 1-1 1H8v3h6c.55 0 1 .45 1 1v4h2c.55 0 1 .45 1 1v.69C16.41 20.12 14.31 21 12 21v-3h-.5zm7.47-.31C18.82 16.73 18 16 17 16h-1v-3c0-1.1-.9-2-2-2H9v-1h1c1.10 0 2-.9 2-2V7h2c1.10 0 2-.9 2-2V3.95c2.96 1.48 5 4.53 5 8.05 0 2.16-.76 4.14-2.03 5.69z"
                        ></path>
                      </svg>
                    </div>
                    Public
                  </span>
                </div>
              </div>
            </div>

            <p class="text-center pt-2 or-txt">OR</p>
            <p class="text-center pt-2">Add to existing groups</p>
            <div>
              <!-- <select
                              class="form-select form-select-lg mb-3 w-100"
                              aria-label=".form-select-lg example"
                              [(ngModel)]="selectedCollectionIndex"
                              >
                              <option selected style="font-weight: 600; font-size: 14px">
                                Select Existing Collection
                              </option>
                              <option
                                *ngFor="let group of existingCollections; let i = index"
                                style="padding: 20px"
                                value="{{ i }}"
                                >
                                {{ group.title }}
                              </option>
                            </select> -->
              <select
                class="form-select form-select-lg mb-3 w-100 custom-select"
                aria-label=".form-select-lg example"
                [(ngModel)]="selectedCollectionIndex"
              >
                <option selected style="font-weight: 600; font-size: 14px">
                  Select Existing Collection
                </option>
                @for (group of existingCollections; track group; let i = $index)
                {
                <option style="padding: 20px" value="{{ i }}">
                  {{ group.title }}
                </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="btn btn-warning create-btn"
            data-dismiss="modal"
            (click)="onAddCollection()"
          >
            Create
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- collaborate modal -->

  <div
    class="modal fade collaborate"
    id="collaborate"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Collaborate</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="resetCollaborateModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="select-content">
            <div class="collaborate-container">
              <p class="caption">
                Collaborators can add videos to this playlist
              </p>

              <label class="switch">
                <input
                  type="checkbox"
                  checked
                  (click)="canAddMediaId = !canAddMediaId"
                />
                <span class="slider round"></span>
              </label>
            </div>
            <div class="collaborate-container">
              <p class="caption">Allow new collaborators</p>
              <label class="switch">
                <input
                  type="checkbox"
                  checked
                  (click)="canAddMembersId = !canAddMembersId"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div class="username-content">
            <div class="mt-2">
              <div>
                <p>Collaborate {{ teamslength }}</p>
              </div>

              <div class="d-flex">
                @for (user of teams; track user; let i = $index) {
                <div class="w-fitcontent">
                  <span
                    [attr.data-letters]="user.user ? user.user[0] : ''"
                  ></span>
                  <p>{{ user.user }}</p>
                </div>
                }
              </div>
            </div>
            <input
              class="form-control mt-2 mb-2"
              type="text"
              [(ngModel)]="searchText"
              placeholder="Search by username"
              (keyup)="filterUsers()"
            />

            <div class="searchUser">
              @for (user of (searchText ? filteredUsers : allUsers); track user; let i = $index) {  @if
              (user.username !== loggedInUsername) {
              <div class="d-flex justify-content-between shareDiv mb-1 mt-1">
                <div>{{ user.username }}</div>
                <div>
                  <button
                    class="btn btn-primary"
                    (click)="toggleInvitation(user)"
                    [ngClass]="{ 'yellow-background': user.invited }"
                  >
                    <!-- {{ user.invited ? "Invited" : "Invite" }} -->
                    Invite
                  </button>
                </div>
              </div>
              } }
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn invite"
            data-dismiss="modal"
            aria-label="Close"
            (click)="getSelectedInvite(slelectedCardDAta)"
          >
            Invite Selected
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade collaborate collaborate1"
    id="shareP"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Share</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="url-container">
            <div
              class="collaborate-conteiner bar style-scope yt-copy-link-renderer"
            >
              <label for="link">Link</label><br />
              <div class="input-content">
                <input
                  id="share-url"
                  dir="ltr"
                  readonly=""
                  size="60"
                  class="style-scope yt-copy-link-renderer"
                  value="{{ inputValue }}"
                />
                <div class="tooltipShare">
                  <button
                    class="btn-url"
                    (click)="myFunction('share-url')"
                    (mouseout)="outFunc()"
                  >
                    <span class="tooltiptext" id="myTooltip"
                      >Copy to clipboard</span
                    >
                    <img src="../../../assets/copy-paste.svg" alt="copy" />
                  </button>
                </div>
              </div>
            </div>
            <div
              class="collaborate-conteiner bar style-scope yt-copy-link-renderer mt-2"
            >
              <label for="password">Password</label><br />
              <div class="input-content">
                <input
                  id="password-url"
                  dir="ltr"
                  readonly=""
                  size="65"
                  class="style-scope yt-copy-link-renderer"
                  value="{{ access_password }}"
                />
                <div class="tooltipShare">
                  <button
                    class="btn-password"
                    (click)="myFunction('password-url')"
                    (mouseout)="outFunc()"
                  >
                    <span class="tooltiptext" id="myTooltip"
                      >Copy to clipboard</span
                    >
                    <img src="../../../assets/copy-paste.svg" alt="copy" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- <button class="btn btn-primary" (click)="onClickShareCollection()">
                                      Send
                                    </button> -->
          <div class="d-flex justify-content-between shareDiv mb-1 mt-1">
            <!-- <div>
                                      <button class="btn btn-primary" (click)="shareFile(user.id)">
                                        Send
                                      </button>
                                    </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="requestModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Requests For Join</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <img src="../../../assets/cross_icon.svg" alt="close" />
          </button>
        </div>
        <div class="modal-body">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Username</th>
                <th scope="col">PlayList</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              @for (play of invitationDetails; track play; let i = $index) {
              <tr>
                <th scope="row">{{ i + 1 }}</th>
                <td>{{ play.senderName }}</td>
                <td>{{ play.collectionTitle }}</td>
                <td>
                  <button
                    (click)="
                      acceptInvitation(
                        i,
                        play.collaborationId,
                        play.collectionId
                      )
                    "
                    class="btn btn-success accept"
                  >
                    Accept
                  </button>
                  <button
                    class="btn btn-danger accept"
                    (click)="rejectInvitation(i, play.collaborationId)"
                  >
                    Reject
                  </button>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Create Deck Modal -->
  <div
    class="modal fade deck-modal-fade"
    id="deckTitleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="deckTitleModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      role="document"
      style="max-width: 480px !important"
    >
      <div class="modal-content deck-modern-modal">
        <div class="deck-modal-header">
          <div class="deck-modal-header-info">
            <div class="deck-modal-icon-badge">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"/>
              </svg>
            </div>
            <div>
              <h5 class="deck-modal-title" id="deckTitleModalLabel">
                Create Deck
              </h5>
              <p class="deck-modal-subtitle">
                Combine selected files into a new presentation deck
              </p>
            </div>
          </div>
          <button
            type="button"
            class="deck-modal-close-btn"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="deck-modal-body">
          @if (selectedPresentations.length > 0) {
            <div class="deck-selection-badge">
              <span class="deck-badge-dot"></span>
              <span>{{ selectedPresentations.length }} presentation{{ selectedPresentations.length > 1 ? 's' : '' }} selected</span>
            </div>
          }
          <div class="deck-form-group">
            <label class="deck-input-label" for="deckTitleInput">Title <span class="required-star">*</span></label>
            <input
              id="deckTitleInput"
              type="text"
              class="form-control deck-input"
              [(ngModel)]="deckTitle"
              placeholder="Enter deck title"
              (keyup.enter)="submitDeck()"
            />
          </div>
        </div>

        <div class="deck-modal-footer">
          <button
            type="button"
            class="btn deck-btn-cancel"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn deck-btn-create"
            [disabled]="isCreating || !deckTitle.trim()"
            (click)="submitDeck()"
          >
            @if (isCreating) {
              <span class="deck-spinner"></span>
              <span>Creating...</span>
            } @else {
              <span>Create</span>
            }
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Download Deck Modal -->
  <div
    class="modal fade deck-modal-fade"
    id="downloadDeckModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="downloadDeckModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 520px !important">
      <div class="modal-content deck-modern-modal">
        <div class="deck-modal-header">
          <div class="deck-modal-header-info">
            <div class="deck-modal-icon-badge">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"/>
              </svg>
            </div>
            <div>
              <h5 class="deck-modal-title" id="downloadDeckModalLabel">
                Download Decks
              </h5>
              <p class="deck-modal-subtitle">
                Browse and download your generated presentation decks
              </p>
            </div>
          </div>
          <button
            type="button"
            class="deck-modal-close-btn"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          class="deck-modal-body deck-download-body"
          infiniteScroll
          #infiniteScroller
          [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="50"
          (scrolled)="onScrollDeck()"
          [scrollWindow]="false"
        >
          @if(this.totalDecks === 0){
          <div class="deck-empty-state">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="#cbd5e1" class="deck-empty-svg">
              <path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"/>
            </svg>
            <h6>No Decks Available</h6>
            <p>Create your first deck by selecting presentations above</p>
          </div>
          } @else {
          <div class="deck-list-container">
            @for(deck of allDecks; track $index){
            <div class="deck-list-card">
              <div class="deck-card-info">
                <span class="deck-card-number">{{ $index + 1 }}</span>
                <div class="deck-card-text">
                  <p class="deck-card-title">{{ deck.title }}</p>
                </div>
              </div>
              <button
                type="button"
                class="btn deck-download-btn"
                title="Download Deck"
                (click)="downloadDeck(deck.fileUrl)"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                </svg>
              </button>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
